// Local translations
export const T = {
  en_GB: {
    blockSettings: "2-Column Block Settings",
    samePageBlockSettings: "Same Page Block Settings",
    blockSettingsDescription: "Configure conditional display for this layout block.",
    conditionalDisplay: "Conditional Display",
    showBlockWhen: "Show this block only when a condition is met",
    when: "When",
    selectField: "Select a field...",
    searchFields: "Search fields…",
    noFieldsAvailable: "No fields available.",
    noFieldsMatch: "No fields match your search.",
    condition: "Condition",
    value: "Value",
    selectValue: "Select a value...",
    searchCountries: "Search countries…",
    noCountriesMatch: "No countries match your search.",
    enterValue: "Enter value to compare...",
    isEmpty: "Is Empty",
    isNotEmpty: "Is Not Empty",
    contains: "Contains",
    notContains: "Does Not Contain",
    cancel: "Cancel",
    save: "Save",
    failedToUpdate: "Failed to update layout",
    // Field labels
    clientCountry: "Client Country",
    classificationType: "Classification Type",
    trapetsPep: "Trapets: PEP Status",
    expectingFinancialChanges: "Expecting Financial Changes",
    trapetsSanctioned: "Trapets: Sanctioned Status",
    sumsubVerified: "Sumsub: Verified Status",
    sumsubDocumentCountry: "Sumsub: Document Country",
    followupMode: "Follow-up Mode",
    goalRiskScore: "Goal: Risk Score",
    goalType: "Goal: Type",
    isOneOf: "Is One Of",
    isNotOneOf: "Is Not One Of",
    portfolioType: "Portfolio: Portfolio Type",
    portfolioScheduleType: "Portfolio: Schedule Type",
    portfolioHasMandateCheck: "Portfolio: Has Mandate Check",
    portfolioMandateStatus: "Portfolio: Mandate Status",
    portfolioModelDeviation: "Portfolio: Model From Another Risk Score",
    modelDeviationYes: "Yes",
    modelDeviationNo: "No",
    modelDeviationNotModel: "Not a model portfolio",
    goalHasRisk: "Goal: Has Risk Assessment",
    goalHasMandate: "Goal: Has Mandate",
    goalRiskScoreCapped: "Goal: Risk Score Capped",
    capStateYes: "Yes",
    capStateNo: "No",
    capStateNoRiskAssessment: "No risk assessment",
    capStateNoClientFieldData: "Cap could not be assessed",
    quizField: "Quiz:",
    flowField: "Flow Field:",
  },
  nb_NO: {
    blockSettings: "2-kolonneblokk-innstillinger",
    samePageBlockSettings: "Innstillinger for Samme side-blokk",
    blockSettingsDescription: "Konfigurer betinget visning for denne layoutblokken.",
    conditionalDisplay: "Betinget visning",
    showBlockWhen: "Vis denne blokken bare når en betingelse er oppfylt",
    when: "Når",
    selectField: "Velg et felt...",
    searchFields: "Søk i felt…",
    noFieldsAvailable: "Ingen felt tilgjengelig.",
    noFieldsMatch: "Ingen felt samsvarer med søket.",
    condition: "Betingelse",
    value: "Verdi",
    selectValue: "Velg en verdi...",
    searchCountries: "Søk i land…",
    noCountriesMatch: "Ingen land samsvarer med søket.",
    enterValue: "Skriv inn verdi å sammenligne...",
    isEmpty: "Er tom",
    isNotEmpty: "Er ikke tom",
    contains: "Inneholder",
    notContains: "Inneholder ikke",
    cancel: "Avbryt",
    save: "Lagre",
    failedToUpdate: "Kunne ikke oppdatere layout",
    // Field labels
    clientCountry: "Kundeland",
    classificationType: "Klassifiseringstype",
    trapetsPep: "Trapets: PEP-status",
    expectingFinancialChanges: "Forventede økonomiske endringer",
    trapetsSanctioned: "Trapets: Sanksjonsstatus",
    sumsubVerified: "Sumsub: Verifiseringsstatus",
    sumsubDocumentCountry: "Sumsub: Dokumentland",
    followupMode: "Oppfølgingsmodus",
    goalRiskScore: "Mål: Risikoscore",
    goalType: "Mål: Måltype",
    isOneOf: "Er en av",
    isNotOneOf: "Er ikke en av",
    portfolioType: "Portefølje: Porteføljetype",
    portfolioScheduleType: "Portefølje: Plantype",
    portfolioHasMandateCheck: "Portefølje: Har mandatkontroll",
    portfolioMandateStatus: "Portefølje: Mandatstatus",
    portfolioModelDeviation: "Portefølje: Modell fra en annen risikoscore",
    modelDeviationYes: "Ja",
    modelDeviationNo: "Nei",
    modelDeviationNotModel: "Ikke en modellportefølje",
    goalHasRisk: "Mål: Har risikovurdering",
    goalHasMandate: "Mål: Har mandat",
    goalRiskScoreCapped: "Mål: Risikoscore begrenset",
    capStateYes: "Ja",
    capStateNo: "Nei",
    capStateNoRiskAssessment: "Ingen risikovurdering",
    capStateNoClientFieldData: "Begrensningen kunne ikke vurderes",
    quizField: "Quiz:",
    flowField: "Flytfelt:",
  },
} as const;
